import { useEffect, useState } from 'react'
import QRCode from 'qrcode'

export function Qr({ value, size = 220 }: { value: string; size?: number }) {
  const [src, setSrc] = useState('')
  useEffect(() => { QRCode.toDataURL(value, { width: size, margin: 1, errorCorrectionLevel: 'M' }).then(setSrc).catch(() => setSrc('')) }, [value, size])
  return src ? <img src={src} width={size} height={size} alt="QR code" style={{ borderRadius: 12, background: '#fff' }} /> : null
}
